wbApp.factory('reportsSvc', ['$resource', 'repositorySvc',
    function ($resource, repositorySvc) {
        var Reports = $resource('/Api/Reports/GetAll', {}, {
            'getRegisteredAttendance': { method: 'GET', isArray: true, url: '/Api/Reports/GetRegisteredAttendance' },
            'getCourseRegistrationSummaryForSemester': { method: 'GET', isArray: true, url: '/Api/Reports/GetCourseRegistrationSummaryForSemester' },
            'getCourseRegistrationSummaryForDateRange': { method: 'GET', isArray: true, url: '/Api/Reports/GetCourseRegistrationSummaryForDateRange' },
            'getOneOffAttendanceSummary': { method: 'GET', isArray: true, url: '/Api/Reports/GetOneOffAttendanceSummary' },

            'getCourseStudentFluctuationOverall': { method: 'GET', isArray: true, url: '/Api/CourseStudentFluctuation/GetOverall' },
            'getCourseStudentFluctuationByTeacher': { method: 'GET', isArray: true, url: '/Api/CourseStudentFluctuation/GetByTeacher' },
            'getCourseStudentFluctuationBySubject': { method: 'GET', isArray: true, url: '/Api/CourseStudentFluctuation/GetBySubject' },
            'getCourseStudentFluctuationByClassroom': { method: 'GET', isArray: true, url: '/Api/CourseStudentFluctuation/GetByClassroom' },

            'getCoursesAttendanceSummaryForDateRange': { method: 'GET', isArray: true, url: '/Api/Reports/GetCoursesAttendanceSummaryForDateRange' },
        });

        function getRegisteredAttendanceAsync(fromDate, toDate) {
            return repositorySvc.customGet('getRegisteredAttendance', Reports, {
                fromDate: fromDate,
                toDate: toDate
            });
        }

        function getCourseRegistrationSummaryForSemester(semesterID) {
            return repositorySvc.customGet('getCourseRegistrationSummaryForSemester', Reports, {
                semesterID: semesterID
            });
        }

        function getCourseRegistrationSummaryForDateRange(fromDate, toDate) {
            return repositorySvc.customGet('getCourseRegistrationSummaryForDateRange', Reports, {
                fromDate: fromDate,
                toDate: toDate
            });
        }

        function getCoursesAttendanceSummaryForDateRange(fromDate, toDate) {
            return repositorySvc.customGet('getCoursesAttendanceSummaryForDateRange', Reports, {
                fromDate: fromDate,
                toDate: toDate
            });
        }

        function getOneOffAttendanceSummary(semesterID) {
            return repositorySvc.customGet('getOneOffAttendanceSummary', Reports, {
                semesterID: semesterID
            });
        }

        function courseStudentFluctuationOverall(fromSemesterID, toSemesterID) {
            return repositorySvc.customGet('getCourseStudentFluctuationOverall', Reports, {
                fromSemesterID: fromSemesterID,
                toSemesterID: toSemesterID
            });
        }

        function courseStudentFluctuationByTeacher(fromSemesterID, toSemesterID, includeNewClients, includeLeavingClients) {
            return repositorySvc.customGet('getCourseStudentFluctuationByTeacher', Reports, {
                fromSemesterID: fromSemesterID,
                toSemesterID: toSemesterID,
                includeNewClients: includeNewClients,
                includeLeavingClients: includeLeavingClients
            });
        }

        function courseStudentFluctuationBySubject(fromSemesterID, toSemesterID, includeNewClients, includeLeavingClients) {
            return repositorySvc.customGet('getCourseStudentFluctuationBySubject', Reports, {
                fromSemesterID: fromSemesterID,
                toSemesterID: toSemesterID,
                includeNewClients: includeNewClients,
                includeLeavingClients: includeLeavingClients
            });
        }

        function courseStudentFluctuationByClassroom(fromSemesterID, toSemesterID, includeNewClients, includeLeavingClients) {
            return repositorySvc.customGet('getCourseStudentFluctuationByClassroom', Reports, {
                fromSemesterID: fromSemesterID,
                toSemesterID: toSemesterID,
                includeNewClients: includeNewClients,
                includeLeavingClients: includeLeavingClients
            });
        }

        return {
            getRegisteredAttendanceAsync: getRegisteredAttendanceAsync,
            getCourseRegistrationSummaryForSemester: getCourseRegistrationSummaryForSemester,
            getCourseRegistrationSummaryForDateRange: getCourseRegistrationSummaryForDateRange,
            getOneOffAttendanceSummary: getOneOffAttendanceSummary,
            courseStudentFluctuationOverall: courseStudentFluctuationOverall,
            courseStudentFluctuationByTeacher: courseStudentFluctuationByTeacher,
            courseStudentFluctuationBySubject: courseStudentFluctuationBySubject,
            courseStudentFluctuationByClassroom: courseStudentFluctuationByClassroom,
            getCoursesAttendanceSummaryForDateRange: getCoursesAttendanceSummaryForDateRange
        }
    }
]);
